import React, { useEffect, useState } from 'react';
import { Box, Button } from '@mui/material';
import CloseIcon from '../assets/images/CloseIcon.png';
import { useSelector } from 'react-redux';
import { MainAppReducer } from 'Types';
import LogOutButton from 'Components/LogOutButton';

const PendingDeletionModal: React.FC = () => {
  const userData = useSelector((state: MainAppReducer) => state.mainAppReducer.userData);
  const pendingDeletion = !!userData?.pending_deletion;

  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (pendingDeletion) {
      setOpen(true);
    }
  }, [pendingDeletion]);

  if (!open) return null;

  return (
    <>
      <Box className="modal-outer" />
      <Box className="modal-inner2">
        <Box className="paywall-desc-container">
          <h3 className="paywall-desc-title">Account deletion pending</h3>
          <p className="paywall-desc-text">
            Your account has been scheduled for deletion. You will lose access once the deletion is
            processed. If this was a mistake, please contact support to resolve it.
          </p>
        </Box>
           <Box className="logout-container">
        <LogOutButton/>
      </Box>
      </Box>
    </>
  );
};

export default PendingDeletionModal;
